import Vue from 'vue';
import inforMsg from '../../components/company-information/infor-msg.vue';
export default Vue.extend({
    name: 'login',
    components: {
        inforMsg: inforMsg,
    },
    data: function () {
        return {
            activeName: 'first',
        };
    },
    created: function () { },
    methods: {
        getCampaignList: function () { },
        handleClick: function (tab, event) { },
    },
});
